import { unit, greekLanguage } from '../lib/constants'

export const unitizeValue = quantity => (quantity ? quantity * unit : 0)
export const unitize = quantity => `${unitizeValue(quantity)}px`

export const localisedLink = (lang, path, slug) => {
    if (lang === greekLanguage) {
        return `/${path}/${slug}`
    }

    return `/${lang}/${path}/${slug}`
}
